module.exports = __webpack_public_path__ + "assets/icons/q-mark.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/sidemenu/q-mark.png
// module id = ./src/styles/icons/sidemenu/q-mark.png
// module chunks = 0